import { twMerge } from "tailwind-merge";

import babylonLogo from "@/ui/common/assets/babylon.svg";
import snowFallLogo from "@/ui/common/assets/SnowFall-logo-w.png";

type SnowFallComboLogoProps = {
  size?: "sm" | "md";
  className?: string;
};

const SIZE_STYLES: Record<
  NonNullable<SnowFallComboLogoProps["size"]>,
  string
> = {
  sm: "h-5",
  md: "h-7",
};

export function SnowFallComboLogo({
  size = "md",
  className,
}: SnowFallComboLogoProps) {
  const logoHeight = SIZE_STYLES[size];

  return (
    <div className={twMerge("flex items-center gap-2", className)}>
      <img
        src={snowFallLogo}
        alt="Snow Fall"
        className={twMerge(logoHeight, "w-auto max-w-none")}
      />
      <span className="tracking-wide text-xs font-semibold uppercase text-accent-secondary">
        x
      </span>
      <img
        src={babylonLogo}
        alt="Babylon"
        className={twMerge(
          logoHeight,
          "w-auto max-w-none invert dark:invert-0",
        )}
      />
    </div>
  );
}
